import {ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CommonModule, NgFor, NgIf} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {LoaderComponent} from "../../loader/loader.component";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {MatTooltipModule} from "@angular/material/tooltip";
import {ToolboxModule} from "../../toolbox.module";
import {HttpClient} from "@angular/common/http";
import {ActivatedRoute, Router} from "@angular/router";
import {DialogComponent} from "../dialog/dialog.component";
import {RxAuthService} from "../../../../services/rx-auth/rx-auth.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Clipboard} from "@angular/cdk/clipboard";

@Component({
    selector: 'app-contact-phone-dialog',
    standalone: true,
    imports: [CommonModule, NgFor, FormsModule, NgIf, LoaderComponent, MatProgressSpinnerModule, MatTooltipModule, ToolboxModule],
    templateUrl: './contact-phone-dialog.component.html',
    styleUrls: ['./contact-phone-dialog.component.scss']
})
export class ContactPhoneDialogComponent implements OnInit {
    constructor(
        public dialog: DialogComponent,
        public auth: RxAuthService,
        public elementRef: ElementRef,
        private cdr: ChangeDetectorRef,
        public snack: MatSnackBar,
        private clipboard: Clipboard,
    ) {

    }

    @Input() contactNumber: any | null = null;
    @Output() closeDialog = new EventEmitter<void>();


    tooltipText = '';


    ngOnInit() {
    }


    functionHandler(fn: (...args: any[]) => void, ...args: any[]): void {
        const maybeEvent = args[args.length - 1];

        if (maybeEvent instanceof Event) {
            maybeEvent.stopPropagation();
            args.pop(); // remove the event from the args passed to the function
        }

        fn.apply(this, args);
    }


    completeCallNumber() {
        if (this.contactNumber) {
            window.location.href = `tel:${this.contactNumber}`;
            this.emitCloseDialog();
        }
    }

    completeCopyNumber() {
        this.clipboard.copy(this.contactNumber)
        let snackRef = this.snack.open('The contact phone number copied to clipboard', 'Accept')
        snackRef._dismissAfter(3000)
        this.emitCloseDialog()
    }


    emitCloseDialog() {
        this.closeDialog.emit();
    }

}
